<div class="main-wrapp">
    <div id="open_cal" class="black-wrapp">
        <input [ngModel]="date" [name]="name" hidden="true" >
        <ion-input
        class="date-input no-border"
        [ngModel]="format(date)"
        type="date_event"
        [disabled]="disabled"
        ></ion-input>
        <app-inline-svg [file]="'assets/img/coach-calendar-main.svg'"></app-inline-svg>
    </div>
    <ion-modal
        trigger="open_cal"
        [keepContentsMounted]="true"
        [initialBreakpoint]="0.65"
    >
        <ng-template>
            <ion-datetime
                [disabled]="disabled"
                presentation="date"
                [(ngModel)]="date"
                mode="md"
                [ngModelOptions]="{standalone: true}"
                (ionChange)="datePick($event)"
                [showDefaultButtons]="true"
                [cancelText]="'__ALERT_CANCEL_BUTTON__' | translate"
                [doneText]="'__ALERT_SUCCESS_BUTTON__' | translate"
                [locale]="locale"
            ></ion-datetime>
        </ng-template>
    </ion-modal>
</div>
